import { render, staticRenderFns } from "./UCategory.vue?vue&type=template&id=59f4db6a&scoped=true&"
import script from "./UCategory.vue?vue&type=script&lang=ts&"
export * from "./UCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4db6a",
  null
  
)

export default component.exports